<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center mb-5'>
      <b-col sm='12' lg='10'>
         <b-row>
           <b-col sm="1">
            <div>
              <el-button class='mb-2' type='warning' icon='el-icon-back' circle @click='goBack'></el-button>
            </div>
           </b-col>
           <b-col sm="10">
             <el-button class='mb-2' type='primary'>{{ '名前: ' + parameter.name }}</el-button>
           </b-col>
           <b-col sm="1">
            <div>
              <el-button class='mb-2' type='info' icon='el-icon-time' round @click='onHistory'>履歴</el-button>
            </div>
           </b-col>
         </b-row>
        <b-card class='shadow-sm bg-white rounded p-0 m-0' border-variant='white' no-body>
          <b-card-body class='p-0 m-0'>
            <b-row>
              <b-col>
                <b-card no-body class='p-0 m-0' border-variant='white'>
                  <b-list-group flush v-chat-scroll='{always: false, smooth: false}' class='px-0 py-0 overflow-x-auto'  style='height: 54vh;'>
                    <div v-for='message in messages' :key='message.key'>
                      <b-list-group-item v-if="message.type === 'text'" flush class='chatBody pb-0' style='min-height: 66px; max-height:640px; border: 0px;'>
                        <div class='d-flex'>
                          <div v-if="message.direction === 'sender'">
                            <div class='p-0 avatar' style='width:40px;'>
                              <img v-if="message.icon" :src='message.icon' alt=''>
                              <i v-else class='fas fa-user-circle fa-3x'></i>
                            </div>
                          </div>
                          <div v-else class='ml-auto'>
                            <b-badge v-if='message.read' variant='primary'>既読</b-badge>
                            <b-badge v-else variant='danger'>未読</b-badge>
                          </div>
                          <div v-if="message.type === 'text'" class='pl-2' style='max-width:180px; min-height: 66px; word-break:break-all;'>
                            <p>{{ message.content }}</p>
                            <div class='p-0'>
                              <p style='font-size: 9px;'>{{ message.createdAt * 1000 | moment }}</p>
                            </div>
                          </div>
                          <div v-if="message.type === 'photo'" class='pl-2' style='max-width:100px;  max-height:100px;'>
                            <a target="_blank" :href="message.content">
                              <div v-if='checkAgent()'>
                                <img :src='message.content' border="0" style='max-width:100px;  max-height:100px;'>
                              </div>
                              <div v-else>
                              <auto-rotate>
                                <img :src='message.content' border="0" style='max-width:100px;  max-height:100px;'>
                              </auto-rotate>
                              </div>
                            </a>
                            <div class='p-0'>
                              <p style='font-size: 9px;'>{{ message.createdAt * 1000 | moment }}</p>
                            </div>
                          </div>
                          <div v-if="message.type === 'movie'" class='pl-2' style='width:230px; height:120px;'>
                            <b-embed align='center'
                              type='video'
                              controls
                              :src='message.content'
                              allowfullscreen
                              ></b-embed>
                            <div class='p-0'>
                              <p style='font-size: 9px;'>{{ message.createdAt * 1000 | moment }}</p>
                            </div>
                          </div>
                        </div>
                      </b-list-group-item>
                      <b-list-group-item v-else flush class='chatBody pb-0' style='height: 150px; max-height:640px; border: 0px;'>
                        <div class='d-flex'>
                          <div v-if="message.direction === 'sender'">
                            <div class='p-0 avatar' style='width:40px;'>
                              <img :src='message.icon' alt=''>
                            </div>
                          </div>
                          <div v-else class='ml-auto'>
                            <b-badge v-if='message.read' variant='primary'>既読</b-badge>
                            <b-badge v-else variant='danger'>未読</b-badge>
                          </div>
                          <div v-if="message.type === 'text'" class='pl-2' style='max-width:180px; min-height: 66px; word-break:break-all;'>
                            <p>{{ message.content }}</p>
                            <div class='p-0'>
                              <p style='font-size: 9px;'>{{ message.createdAt * 1000 | moment }}</p>
                            </div>
                          </div>
                          <div v-if="message.type === 'photo'" class='pl-2' style='max-width:100px; max-height:100px;'>
                            <a target="_blank" :href="message.content">
                              <div v-if='checkAgent()'>
                                <img :src='message.content' border="0" style='max-width:100px;  max-height:100px;'>
                              </div>
                              <div v-else>
                              <auto-rotate>
                                <img :src='message.content' border="0" style='max-width:100px;  max-height:100px;'>
                              </auto-rotate>
                              </div>
                            </a>
                            <div class='p-0'>
                              <p style='font-size: 9px;'>{{ message.createdAt * 1000 | moment }}</p>
                            </div>
                          </div>
                          <div v-if="message.type === 'movie'" class='pl-2' style='width:230px; height:120px;'>
                            <b-embed align='center'
                              type='video'
                              controls
                              :src='message.content'
                              allowfullscreen
                              ></b-embed>
                            <div class='p-0'>
                              <p style='font-size: 9px;'>{{ message.createdAt * 1000 | moment }}</p>
                            </div>
                          </div>
                        </div>
                      </b-list-group-item>
                    </div>
                  </b-list-group>
                  <el-input size='medium' maxlength="200" v-model='message' type='text' placeholder='メッセージを入力してください' @keyup.enter='send'>
                      <el-upload slot='prepend'
                        class='upload-demo'
                        action=''
                        :accept='"image/*, video/*"'
                        :auto-upload=false
                        :show-file-list=false
                        :on-change='selectFile'
                        :file-list='fileList'>
                        <el-button  size='small' title='画像を送信します'><i class='far fa-image my-blue'></i></el-button>
                      </el-upload>
                    <el-button slot='append' class='m-0 p-1'>{{ message.length + '/200' }}</el-button>
                    <el-button slot='append' v-on:click='send' title='メッセージを送信します' class='m-0 p-1'><i class='far fa-paper-plane my-green'></i></el-button>
                    <el-button slot='append' v-on:click='achieve' title='ルーティンやりました！' class='mr-1 p-0'><i class='fas fa-star my-primary'></i></el-button>
                  </el-input>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref='errorModal' centered title='エラー' class='text-primary' size='sm' ok-variant=primary header-bg-variant=primary ok-only>
      <p class='my-4'>{{errorMessage}}</p>
    </b-modal>
    <b-modal ref='chatMessage'
      header-bg-variant=primary
      centered title='メッセージ'
      class='text-dark'
      size='sm'
      header-border-variant='white'
      footer-border-variant="white"
      @ok='sendTextMessage'
      >
      <b-container fluid>
        <b-form-group>
          <b-form-radio-group v-model="selected"
                          :options="options"
                          stacked
                          name="radiosStacked">
          </b-form-radio-group>
        </b-form-group>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
// import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'
import firebase from 'firebase/app'
import 'firebase/storage'
import moment from 'moment'
import { mapGetters } from 'vuex'
import VueChatScroll from 'vue-chat-scroll'
import AutoRotate from '@/components/AutoRotate'
Vue.use(VueChatScroll)

// Vue.use(Viewer)
// Viewer.setDefaults({
//   toolbar: false,
//   title: false,
//   fullscreen: false,
//   navbar: false
// })
export default {
  components: {
    AutoRotate
  },
  install (Vue) {
    Vue.component('autoRotate', AutoRotate)
  },
  data: () => {
    return {
      unwatch: null,
      unwatch1: null,
      messages: [],
      message: '',
      fileList: [],
      errorMessage: '',
      isInit: false,
      selected: 'first',
      options: [
        { text: 'ルーティンやりました❗️', value: 'first' },
        { text: '👍', value: 'second' }
      ],
      loader: null
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
  },
  created () {
    this.$nextTick().then(() => {
      this.unwatch = this.$store.watch(state => this.$store.getters['chatMessage/chatMessage'], value => {
        this.init()
      })
      this.init()
    })
  },
  methods: {
    onSendingProgress () {
      if (this.loader === null) {
        this.loader = this.$loading({
          lock: true,
          text: '',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          if (this.loader) {
            this.loader.close()
            this.loader = null
          }
        }, 420000)
      }
    },
    offSendingProgress () {
      if (this.loader) {
        this.loader.close()
        this.loader = null
      }
    },
    checkAgent () {
      if ((navigator.userAgent.indexOf('iPad') !== -1) || (navigator.userAgent.indexOf('iPhone') !== -1)) {
        return true
      }
      return false
    },
    selectFile (file) {
      var vm = this
      if (file.size > 300 * 1000 * 1000) {
        vm.errorMessage = 'ファイルサイズが 300Mbyteを超えています'
        vm.showModal()
        return
      }
      this.onSendingProgress()
      var uuid = this.generateUuid()
      var storageRef = firebase.storage().ref().child('messages').child(this.user.key).child(uuid)
      var uploadTask = storageRef.put(file.raw)
      uploadTask.on('state_changed', function (snapshot) {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        vm.loader.text = 'Upload is ' + Math.floor(progress) + '% done'
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            break
          case firebase.storage.TaskState.RUNNING: // or 'running'
            break
        }
      }, function (error) {
        vm.offSendingProgress()
        vm.errorMessage = error.errorMessage
        vm.showModal()
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          var type = 'photo'
          if (file.raw.type !== 'image/jpeg' && file.raw.type !== 'image/png') {
            type = 'movie'
          }
          vm.sendSub(type, downloadURL).then(() => {
            vm.offSendingProgress()
          })
        })
      })
    },
    init () {
      if (this.isInit) {
        return
      }
      var vm = this
      var async = require('async')
      this.isInit = true
      var messages = []
      async.each(vm.chatMessage[vm.parameter.location], function (data, cb) {
        var payload = {
          key: data.key,
          direction: 'sender',
          icon: '',
          read: data.read,
          type: data.type,
          chatType: data.chatType,
          content: data.content,
          createdAt: data.createdAt,
          updatedAt: data.updatedAt
        }
        if (data.from === vm.user.key) {
          payload.direction = 'receiver'
        }
        var index = vm.users.findIndex(user => user.key === data.from)
        if (index !== -1) {
          payload.icon = vm.users[index].icon
          messages.push(payload)
        } else {
          messages.push(payload)
        }
        if (data.read === false && payload.direction === 'sender') {
          vm.setRead(data).then(() => {
            cb()
          })
        } else {
          cb()
        }
      }, function (err) {
        if (err) console.log(err)
        vm.messages = []
        vm.messages = messages
        vm.isInit = false
      })
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    goBack () {
      this.$router.go(-1)
    },
    onHistory () {
      this.$router.push({path: '/chat/history'})
    },
    sendSub (type, content) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('chats').doc(this.parameter.location).collection('data')
        const payload = {
          chatType: this.parameter.type,
          content: content,
          from: this.user.key,
          to: this.parameter.key,
          read: false,
          type: type,
          visible: true,
          createdAt: parseInt(new Date().getTime() / 1000),
          updatedAt: parseInt(new Date().getTime() / 1000)
        }
        dbRef.add(payload)
          .then(function (docRef) {
            resolve()
          })
          .catch(function (error) {
            if (error) console.log(error)
            resolve()
          })
      })
    },
    sendTextMessage () {
      var vm = this
      var index = this.options.findIndex(option => option.value === this.selected)
      if (index !== -1) {
        vm.offLoading()
        vm.sendSub('text', vm.options[index].text).then(() => {
          vm.selected = 'first'
          vm.offLoading()
        })
      }
    },
    achieve () {
      this.$refs.chatMessage.show()
    },
    send () {
      var vm = this
      vm.offLoading()
      if (this.message === '') {
        return
      }
      this.sendSub('text', this.message).then(() => {
        this.message = ''
        vm.offLoading()
      })
    },
    setRead (data) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('chats').doc(data.parentKey).collection('data').doc(data.key)
        const payload = {
          chatType: data.chatType,
          content: data.content,
          from: data.from,
          to: data.to,
          read: true,
          type: data.type,
          visible: data.visible,
          createdAt: data.createdAt,
          updatedAt: parseInt(new Date().getTime() / 1000)
        }
        dbRef.set(payload).then(function () {
          resolve()
        })
      })
    },
    getStatus (value) {
      for (var index in this.chatRef) {
        var ref = this.chatRef[index]
        if (ref.key === value.item.key) {
          return ref.status
        }
      }
      return null
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MM/DD HH:mm')
    }
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      chatRef: 'chatRef/chatRef',
      chatMessage: 'chatMessage/chatMessage',
      parameter: 'dispatch/chat'
    })
  }
}
</script>

<style>
.my-blue {color: blue}
.my-green {color: green}
.my-primary {color: #52a7d3}
/* viewer {
 max-width: 100%;
 max-height: 100%;
 width: auto;
 height: auto;
} */
</style>



// WEBPACK FOOTER //
// src/components/ChatMessage.vue